import { render, staticRenderFns } from "./BaseAudioPlayer.vue?vue&type=template&id=21743dfc&scoped=true&"
import script from "./BaseAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./BaseAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BaseAudioPlayer.vue?vue&type=style&index=0&id=21743dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21743dfc",
  null
  
)

export default component.exports